import Immutable from 'immutable';
import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setJobGrid = (state, { jobGrid }) => {
  if (!jobGrid) return state;
  return state.merge({ jobGrid });
};

const setErpWorkOrderNoExist = (state, { erpWorkOrderNoData }) => {
  return state.merge({ erpWorkOrderNoData });
};

const setaddUpdateJob = (state, { addUpdateJobData }) => {
  return state.merge({ addUpdateJobData });
};

const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};

const setJobToolCavityLoader = (state, { showJobToolCavityLoader }) => {
  return state.merge({ showJobToolCavityLoader });
};

const setMoveUnassignedJob = (state, { lineJob }) => {
  return state.merge({ lineJob });
};

const setJobScheduleModalState = (state, { cardData }) => {
  return state.merge({ cardData });
};

const setUnassignedJobs = (state, { unAssignedJobs }) => {
  if (!unAssignedJobs) return state;
  return state.merge({ unAssignedJobs });
};

const modalSetProductTool = (state, { productTool }) => {
  if (!productTool) return state;
  return state.merge({ productTool });
};

const setProductToolLoader = (state, { productToolLoader }) => {
  return state.merge({ productToolLoader });
};

const updateCheck = (state, { updateJob }) => {
  return state.merge({ updateJob });
};

//Job Timing Calculations
const setJobTiming = (state, { jobTiming }) => {
  if (!jobTiming) return state;
  return state.merge({ jobTiming });
};

const setAllPackingTypes = (state, { allPackingTypes }) => {
  if (!allPackingTypes) return state;
  return state.merge({ allPackingTypes });
};

const setJobTimingLoader = (state, { jobTimingLoader }) => {
  return state.merge({ jobTimingLoader });
};

// Equipment Jobs
const setEquipmentJobs = (state, { equipmentJobsData }) => {
  if (!equipmentJobsData) return state;
  return state.merge({ equipmentJobsData });
};

const setEquipmentJobsLoaderStatus = (state, { equipmentJobsLoader }) => {
  return state.merge({ equipmentJobsLoader });
};

// Job Active Maintenance
const setJobActiveMaintenance = (state, { jobActiveMaintenance }) => {
  if (!jobActiveMaintenance) return state;
  return state.merge({ jobActiveMaintenance });
};

const setJobActiveMaintenanceLoader = (state, { jobActiveMaintenanceLoader }) => {
  return state.merge({ jobActiveMaintenanceLoader });
};

// Set Job by Id
const setJobByID = (state, { updateJobData }) => {
  if (!updateJobData) return state;
  return state.merge({ updateJobData });
};

// Set Job by Id
const setLineConfigByLineId = (state, { lineConfigData }) => {
  if (!lineConfigData) return state;
  return state.merge({ lineConfigData });
};

// Set Job camera attributes
const setJobCameraProductAttributesByLineAndProduct = (state, { jobCameraAttributesData }) => {
  if (!jobCameraAttributesData) return state;
  return state.merge({ jobCameraAttributesData });
};

// Set Job by Id
const setLineJobByID = (state, { updateLineJobData }) => {
  if (!updateLineJobData) return state;
  return state.merge({ updateLineJobData });
};

const setJobByIDLoader = (state, { jobIdLoader }) => {
  return state.merge({ jobIdLoader });
};

const setlineConfigLoader = (state, { lineConfigLoader }) => {
  return state.merge({ lineConfigLoader });
};

// Set Product Data by Tool Id
const setProductsByToolId = (state, { productsData }) => {
  if (!productsData) return state;
  return state.merge({ productsData });
};

const setProductsByToolIdLoader = (state, { productsByToolIdLoader }) => {
  return state.merge({ productsByToolIdLoader });
};

const setIndefiniteExist = (state, { exist }) => {
  return state.merge({ exist });
};

const setToolCavityTable = (state, { toolCavityTable }) => {
  if (!toolCavityTable) return state;
  return state.merge({ toolCavityTable });
};

const setExcelJobFile = (state, { exportJobFile }) => {
  return state.merge({ exportJobFile });
};

const setImportExcelJobFile = (state, { importJobFile }) => {
  return state.merge({ importJobFile });
};

const setExportExcelJobFileLoader = (state, { exportExcelFileLoader }) => {
  return state.merge({ exportExcelFileLoader });
};
const setImportExcelJobFileLoader = (state, { importExcelFileLoader }) => {
  return state.merge({ importExcelFileLoader });
};

const setJobsByFactory = (state, { factoryJobs }) => {
  return state.merge({ factoryJobs });
};

const setLineProductConfiguration = (state, { lineConfigurationData }) => {
  return state.merge({ lineConfigurationData });
};

const fetchFilesForDownload = (state, { rowId, fileName }) => {
  return state.merge({ rowId, fileName });
};

const setFilesForDownload = (state, { downloadJobDocFile }) => {
  if (!downloadJobDocFile) return state;
  return state.merge({ downloadJobDocFile });
};

const deleteJobDocFiles = (state, { rowId, fileName, jobGridParams, isOperator }) => {
  return state.merge({ rowId, fileName, jobGridParams, isOperator });
};
const setAccumulationLoader = (state, { showLoader }) => {
  return state.merge({ accumulationLoader: showLoader });
};
const setLineJobPlcStatus = (state, { lineJobStateParams, jobGridParams }) => {
  return state.merge({ lineJobStateParams, jobGridParams });
};

const setJobPlcStatus = (state, { jobPlcParams, jobGridParams }) => {
  return state.merge({ jobPlcParams, jobGridParams });
};
const setJobImages = (state, { jobImages }) => {
  return state.merge({ jobImages });
};
const setJobImageTypes = (state, { jobImageTypes }) => {
  return state.merge({ jobImageTypes });
};

const setJobIds = (state, { jobIdsData }) => {
  return state.merge({ jobIdsData });
};

const setIsJobRecordExist = (state, { isJobRecordExist }) => {
  return state.merge({ isJobRecordExist });
};

// Add handler for SET_JOB_BY_EQUIP_ID
const setJobByEquipId = (state, { jobByEquipId }) => {
  if (!jobByEquipId) return state;
  return state.merge({ jobByEquipId });
};

// Add handler for SET_JOB_BY_LINE_ID
const setJobByLineId = (state, { jobByLineId }) => {
  if (!jobByLineId) return state;
  return state.merge({ jobByLineId });
};

// Camera Health
const setCameraHealth = (state, { cameraHealthData }) => {
  if (!cameraHealthData) return state;
  // Use fromJS to ensure deep immutable conversion for proper change detection
  return state.set('cameraHealthData', Immutable.fromJS(cameraHealthData));
};

// Camera Health Refreshing state (tracks which cameras are being refreshed)
const setCameraHealthRefreshing = (state, { refreshingCameras }) => {
  return state.set('cameraHealthRefreshing', Immutable.fromJS(refreshingCameras || {}));
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_MOVE_UNASSIGNED_JOB,
    actionFunction: setMoveUnassignedJob,
  },
  {
    actionType: ActionTypes.DELETE_JOB_DOC_FILES,
    actionFunction: deleteJobDocFiles,
  },
  {
    actionType: ActionTypes.SET_FILES_FOR_DOWNLOAD,
    actionFunction: setFilesForDownload,
  },
  {
    actionType: ActionTypes.FETCH_FILES_FOR_DOWNLOAD,
    actionFunction: fetchFilesForDownload,
  },
  {
    actionType: ActionTypes.SET_JOB_GRID,
    actionFunction: setJobGrid,
  },

  {
    actionType: ActionTypes.SET_JOB_SCHEDULE_STATE,
    actionFunction: setJobScheduleModalState,
  },

  {
    actionType: ActionTypes.SET_ERP_WORK_ORDER_NO_EXIST,
    actionFunction: setErpWorkOrderNoExist,
  },
  {
    actionType: ActionTypes.SET_TOOL_CAVITY_TABLE,
    actionFunction: setToolCavityTable,
  },
  {
    actionType: ActionTypes.SET_ADD_OR_UPDATE_JOB,
    actionFunction: setaddUpdateJob,
  },
  {
    actionType: ActionTypes.SET_UNASSIGNED_JOBS,
    actionFunction: setUnassignedJobs,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
  {
    actionType: ActionTypes.SET_JOB_TOOL_CAVITY_LOADER_STATUS,
    actionFunction: setJobToolCavityLoader,
  },
  {
    actionType: ActionTypes.SET_JOB_CAMERA_PRODUCT_ATTRIBUTES_BY_LINE_AND_PRODUCT,
    actionFunction: setJobCameraProductAttributesByLineAndProduct,
  },
  {
    actionType: ActionTypes.MODAL_SET_PRODUCT_TOOL,
    actionFunction: modalSetProductTool,
  },
  {
    actionType: ActionTypes.SET_PRODUCT_TOOL_LOADER_STATUS,
    actionFunction: setProductToolLoader,
  },
  {
    actionType: ActionTypes.CHECK_JOB_UPDATE,
    actionFunction: updateCheck,
  },
  {
    actionType: ActionTypes.SET_JOB_TIMING,
    actionFunction: setJobTiming,
  },
  {
    actionType: ActionTypes.SET_JOB_TIMING_LOADER_STATUS,
    actionFunction: setJobTimingLoader,
  },
  {
    actionType: ActionTypes.SET_EQUIPMENT_JOBS,
    actionFunction: setEquipmentJobs,
  },
  {
    actionType: ActionTypes.SET_JOB_ACTIVE_MAINTENANCE,
    actionFunction: setJobActiveMaintenance,
  },
  {
    actionType: ActionTypes.SET_JOB_ACTIVE_MAINTENANCE_LOADER_STATUS,
    actionFunction: setJobActiveMaintenanceLoader,
  },
  {
    actionType: ActionTypes.SET_PACKINGTYPES,
    actionFunction: setAllPackingTypes,
  },
  {
    actionType: ActionTypes.SET_JOB_DATA_BY_JOB_ID,
    actionFunction: setJobByID,
  },
  {
    actionType: ActionTypes.SET_LINE_CONFIG_DATA_BY_LINE_ID,
    actionFunction: setLineConfigByLineId,
  },
  {
    actionType: ActionTypes.SET_LINE_JOB_DATA_BY_LINE_JOB_ID,
    actionFunction: setLineJobByID,
  },
  {
    actionType: ActionTypes.SET_JOB_DATA_BY_JOB_ID_LOADER_STATUS,
    actionFunction: setJobByIDLoader,
  },
  {
    actionType: ActionTypes.SET_LINE_CONFIG_LOADER_STATUS,
    actionFunction: setlineConfigLoader,
  },
  {
    actionType: ActionTypes.SET_PRODUCT_DATA_BY_TOOL_ID,
    actionFunction: setProductsByToolId,
  },
  {
    actionType: ActionTypes.SET_PRODUCT_DATA_BY_TOOL_ID_LOADER_STATUS,
    actionFunction: setProductsByToolIdLoader,
  },
  {
    actionType: ActionTypes.SET_INDEFINITE_EXIST,
    actionFunction: setIndefiniteExist,
  },
  {
    actionType: ActionTypes.SET_EXCEL_JOB_FILE,
    actionFunction: setExcelJobFile,
  },
  {
    actionType: ActionTypes.SET_IMPORT_EXCEL_JOB_FILE,
    actionFunction: setImportExcelJobFile,
  },
  {
    actionType: ActionTypes.SET_EXPORT_EXCEL_JOB_FILE_LOADER_STATUS,
    actionFunction: setExportExcelJobFileLoader,
  },
  {
    actionType: ActionTypes.SET_IMPORT_EXCEL_JOB_FILE_LOADER_STATUS,
    actionFunction: setImportExcelJobFileLoader,
  },
  {
    actionType: ActionTypes.SET_JOBS_BY_FACTORY,
    actionFunction: setJobsByFactory,
  },
  {
    actionType: ActionTypes.SET_LINE_PRODUCT_CONFIGURATION,
    actionFunction: setLineProductConfiguration,
  },
  {
    actionType: ActionTypes.SET_ACCUMULATION_LOADER,
    actionFunction: setAccumulationLoader,
  },
  {
    actionType: ActionTypes.SET_LINE_JOB_PLC_STATUS,
    actionFunction: setLineJobPlcStatus,
  },
  {
    actionType: ActionTypes.SET_JOB_PLC_STATUS,
    actionFunction: setJobPlcStatus,
  },
  {
    actionType: ActionTypes.SET_JOB_IMAGES,
    actionFunction: setJobImages,
  },
  {
    actionType: ActionTypes.SET_JOB_IMAGE_TYPES,
    actionFunction: setJobImageTypes,
  },
  {
    actionType: ActionTypes.SET_JOB_IDS,
    actionFunction: setJobIds,
  },
  {
    actionType: ActionTypes.SET_IS_JOB_RECORD_EXIST,
    actionFunction: setIsJobRecordExist,
  },
  // Add callback for SET_JOB_BY_EQUIP_ID
  {
    actionType: ActionTypes.SET_JOB_BY_EQUIP_ID,
    actionFunction: setJobByEquipId,
  },
  // Add callback for SET_JOB_BY_LINE_ID
  {
    actionType: ActionTypes.SET_JOB_BY_LINE_ID,
    actionFunction: setJobByLineId,
  },
  // Camera Health
  {
    actionType: ActionTypes.SET_CAMERA_HEALTH,
    actionFunction: setCameraHealth,
  },
  {
    actionType: ActionTypes.SET_CAMERA_HEALTH_REFRESHING,
    actionFunction: setCameraHealthRefreshing,
  },
];
